<template>
<div class="chapter">
<div class="inner_page">
<p class="part">The Heart of Darkness</p>
<p class="ct1"><span>Fairfax, Virginia:<br/>Monday, November 18, 1991; 10:00 <span class="small">P.M.</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?99c1cd12